import { render, staticRenderFns } from "./AnswerTimer.vue?vue&type=template&id=021bcd55&scoped=true&"
import script from "./AnswerTimer.vue?vue&type=script&lang=js&"
export * from "./AnswerTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021bcd55",
  null
  
)

export default component.exports